import useScrollReveal from '../hooks/useScrollReveal';

import calendarImgSvg from '../assets/images/calendar.svg';
import infinityImgSvg from '../assets/images/infinity.svg';

export default function GameModes() {
  const [ref, visible] = useScrollReveal();

  return (
    <section className="section">
      <div className="container section-content">

        <div ref={ref} className={`reveal ${visible ? 'visible' : ''}`} style={{ textAlign: 'center', marginBottom: 8 }}>
          <h2 className="section-headline">Game Modes</h2>
          <p className="section-sub" style={{ marginTop: 8 }}>Two ways to play — both endlessly satisfying.</p>
        </div>

        <div className="modes-grid" style={{ marginTop: 40 }}>

          {/* Daily Puzzle */}
          <div className="mode-card" style={{ borderColor: 'rgba(51,170,255,0.2)' }}>
            <div className="mode-chip" style={{ background: 'rgba(51,170,255,0.12)', color: 'var(--accent)' }}>
              Daily
            </div>
            <img src={calendarImgSvg} alt="Daily puzzle" style={{ width: 80, height: 80, objectFit: 'contain' }} />
            <div className="mode-title">Daily Puzzle</div>
            <div className="mode-features">
              <div className="mode-feature">One new puzzle every day, the same for every player worldwide</div>
              <div className="mode-feature">Compete with yourself to improve your tap count day over day</div>
              <div className="mode-feature">Streak tracking — keep your daily streak alive</div>
            </div>
          </div>

          {/* Endless */}
          <div className="mode-card" style={{ borderColor: 'rgba(255,215,0,0.2)' }}>
            <div className="mode-chip" style={{ background: 'rgba(255,215,0,0.12)', color: 'var(--gold)' }}>
              <img src={infinityImgSvg} alt="" aria-hidden="true" style={{ width: 18, height: 18, objectFit: 'contain', filter: 'brightness(0) saturate(100%) invert(85%) sepia(60%) saturate(500%) hue-rotate(5deg) brightness(110%)' }} />
              Endless
            </div>
            <img src={infinityImgSvg} alt="Endless mode" style={{ width: 80, height: 80, objectFit: 'contain' }} />
            <div className="mode-title" style={{ color: 'var(--gold)' }}>Endless Play</div>
            <div className="mode-features">
              <div className="mode-feature">Easy (par ≈ 4–8 taps), Medium (par ≈ 7–13), Hard (par ≈ 10–20)</div>
              <div className="mode-feature">Generate unlimited puzzles — never the same board twice</div>
              <div className="mode-feature">Perfect for practice and mastering the ripple mechanic</div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}
